var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPermissionError = function SvgPermissionError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.212.133A3.89 3.89 0 0 1 94.97 1.14l50.996 50.996a3.89 3.89 0 0 1 1.007 3.758l-18.666 69.662a3.89 3.89 0 0 1-2.751 2.751l-69.662 18.666a3.89 3.89 0 0 1-3.758-1.007L1.14 94.97a3.89 3.89 0 0 1-1.007-3.758l18.666-69.663a3.89 3.89 0 0 1 2.75-2.75L91.212.133Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.722 49.669V38.053c0-5.68-3.604-9.284-9.284-9.284-5.68 0-9.284 3.604-9.284 9.284v11.616h18.568Zm-9.284-27.794c-8.935 0-16.178 7.243-16.178 16.178V55.563h32.356V38.053c0-8.935-7.243-16.178-16.178-16.178Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.616 49.576a4 4 0 0 0-4 4v43.885c0 10.85 8.796 19.646 19.646 19.646h29.47c10.85 0 19.646-8.796 19.646-19.646V53.576a4 4 0 0 0-4-4H43.616ZM75 70a8 8 0 0 0-2.584 15.573 2.63 2.63 0 0 0-.013.259v8.596a2.578 2.578 0 0 0 5.156 0v-8.596c0-.083-.004-.165-.011-.246A8 8 0 0 0 75 70Z",
    fill: "#FAFAFA"
  })));
};
export default SvgPermissionError;